import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import logo from '../images/dehaalogo-trim.png';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  return (
    <footer className="site-footer"><div className="wrap">
      <div className="footer-top">
        <div style={{ flex: '1 1 280px', maxWidth: 340 }}>
          <Link className="footer-logo" to="/" aria-label="Dehaa Technology — home">
            <img src={logo} alt="Dehaa Technology" width={168} height={56} loading="lazy" style={{ filter: 'brightness(0) invert(1)', opacity: 0.9 }} />
          </Link>
          <p className="dek" style={{ marginTop: '1.4em', color: 'var(--on-dark-dim)', fontSize: 'var(--t--1)' }}>
            Dehaa Technology — Websites, AI & systems for Saudi businesses. Riyadh · Saudi Arabia.
          </p>
        </div>
        <div className="footer-cols">
          <div><div className="lbl">Services</div>
            <Link className="val" to="/services">Web Design</Link>
            <Link className="val" to="/services">E-Commerce</Link>
            <Link className="val" to="/services">AI Solutions</Link>
            <Link className="val" to="/pricing">Pricing</Link>
            <a className="val" href="/demos/ecommerce/index.html">Demos</a>
          </div>
          <div><div className="lbl">Company</div>
            <Link className="val" to="/about">About</Link>
            <Link className="val" to="/process">Our Process</Link>
            <Link className="val" to="/industries">Industries</Link>
            <Link className="val" to="/portfolio">Portfolio</Link>
            <Link className="val" to="/faq">FAQ</Link>
          </div>
          <div><div className="lbl">Contact</div>
            <span className="val">Riyadh, Saudi Arabia</span>
            <a className="val" href="mailto:dehaatechnology@gmail.com">dehaatechnology@gmail.com</a>
            <a className="val" href="tel:+966579468040"><bdi>+966 579 468 040</bdi></a>
            <Link className="val" to="/contact">Start a Project</Link>
            <a className="val" href="https://wa.me/966579468040">WhatsApp</a>
          </div>
        </div>
      </div>
    </div>
      <div className="ghost-word" aria-hidden="true">DEHAA</div>
      <div className="footer-bottom"><div className="footer-bottom-inner">
        <span>© 2026 Dehaa Technology — All Rights Reserved</span>
        <span className="legal"><Link to="/about">About</Link><Link to="/contact">Contact</Link><Link to="/faq">FAQs</Link><Link to="/portfolio">Portfolio</Link></span>
      </div></div>
    </footer>
  );
};
export default Footer;
